import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import RosterView from '../components/roster/RosterView';
import { RosterProvider } from '../context/RosterContext';

const Roster = () => {
    const { ready } = useTranslation('roster');
    const { classUuid } = useParams<{ classUuid: string }>();

    const search = new URLSearchParams(window.location.search);
    const userUuid = window.localStorage.getItem('user_uuid');
    const isDemo = search.get('isDemo');
    const classId = search.get('class_id');

    if (!ready) {
        return <CircularProgress />;
    }

    return (
        <RosterProvider classId={classId} classUuid={classUuid} userUuid={userUuid} isDemo={isDemo}>
            <RosterView />
        </RosterProvider>
    );
};

export default Roster;
